// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"sceneLoadingOverlay_loaderContainer__hWK3e","loaderText":"sceneLoadingOverlay_loaderText__11Cms","loaderSubText":"sceneLoadingOverlay_loaderSubText__9fgBF"};